import MainLayout from "@core/layouts/MainLayout";
import { routes } from "@core/router/routes";
import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { Toaster } from "@shared/ui/toaster"; // Import your Toaster
import { initAmplitude, initPosthog } from "./shared/analytics/analytics";
import { usePageTracking } from "@shared/hooks/usePageTracking";

const App: React.FC = () => {
  console.log('Active Mode:', import.meta.env.MODE);
  console.log('AUTH Endpoint:', import.meta.env.VITE_AUTH_API_ENDPOINT);
  useEffect(() => {
    initPosthog();
  }, []);
  usePageTracking();
  return (
    <>
      <Routes>
        <Route element={<MainLayout />}>
          {routes.map((route) => (
            <Route key={route.path} path={route.path} element={route.element} />
          ))}
        </Route>
      </Routes>
      <Toaster /> {/* Add this line */}
    </>
  );
};

export default App;